// extracted by mini-css-extract-plugin
export default {"NoProgressTable":"styles_NoProgressTable__QFKIy"};